import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  container: {
    height: '500px',
    width: '100%',
  },
});

export default useStyles;
